import { GR_MEDIA_TYPES, GR_VID_TYPES } from '@/types/greenroom/gr-constants';

const isVideo = (urlOrType: string): boolean => {
  if (!urlOrType) return false;
  const videoTypes = [...GR_VID_TYPES, GR_MEDIA_TYPES.HLS];
  const inputType = urlOrType.includes('.') ? (urlOrType.split('.').pop() ?? '') : urlOrType;
  return videoTypes.some((videoType: string) => videoType === inputType.toLowerCase());
};

export default isVideo;
